import { DocumentStore } from './DocumentStore';
import { UIStore } from './UIStore';
import { UserStore } from './UserStore';

/**
 * RootStore - Central store that manages all domain stores
 * Follows the Root Store pattern for MobX state management
 */
export class RootStore {
  uiStore: UIStore;
  userStore: UserStore;
  documentStore: DocumentStore;

  constructor() {
    // Initialize stores (order matters if stores depend on each other)
    this.uiStore = new UIStore(this);
    this.userStore = new UserStore(this);
    this.documentStore = new DocumentStore(this);
  }
}
